
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  reactive,
  ref,
  watch
} from "vue";
import { useStore } from "@/store";
import { SysInfo, sysInfoMap } from "@/const/sys";
import { SysActionTypes } from "@/store/sys/action-types";
import { WsDTO } from "@/const/ws";
import { MutationTypes } from "@/store/sys/mutation-types";
const store = useStore();
export default defineComponent({
  name: "sysInfo",
  setup() {
    const sysInfoContent = ref(null);
    const textMsg = ref("");
    const tabValue = ref(-1);
    const scrollToBootom = (el: any) => {
      el.value.scrollTop = el.value.scrollHeight;
    };
    const sysInfoList = computed(() => {
      return store.state.sysInfo.filter(m => {
        if (tabValue.value !== -1) {
          return tabValue.value === m.source;
        }
        return true;
      });
    });
    const sourceType = reactive(sysInfoMap.sourceType);
    const type = reactive(sysInfoMap.type);
    watch(store.state.sysInfo, () => {
      nextTick(() => {
        scrollToBootom(sysInfoContent);
      });
    });
    onMounted(() => {
      scrollToBootom(sysInfoContent);
    });
    const handleClear = () => {
      store.commit(MutationTypes.CLEAR_SYS_INFO, tabValue.value);
    };
    const handleSend = () => {
      if (textMsg.value) {
        const body = {
          code: 0,
          data: new SysInfo(
            textMsg.value,
            5,
            null,
            1,
            store.state.userInfo.userName
          )
        };
        const data = new WsDTO(
          store.state.userInfo.userName,
          body,
          1,
          0
        ).ObjectToString();
        store.dispatch(SysActionTypes.SYS_WS_SEND, data);
        textMsg.value = "";
      }
    };
    const handleTab = (v: number) => {
      tabValue.value = v;
    };
    return {
      sysInfoList,
      sysInfoContent,
      sourceType,
      type,
      textMsg,
      handleSend,
      handleClear,
      tabValue,
      handleTab,
      tabList: [
        {
          label: "全部",
          value: -1
        },
        {
          label: "世界",
          value: 1
        },
        {
          label: "系统",
          value: 0
        }
      ]
    };
  }
});
